angular.module('unergie.main')
.controller('jiraCommentsModalCtrl', ($scope, $uibModalInstance, AuthService, ApiAdmin, ErrorCatcher, idJira, issueType, readOnly, BoFeaturesService, JiraService) => {
    $scope.isComplaintsFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('complaints')[feature]
    $scope.close = () => $uibModalInstance.dismiss()

    $scope.idJira = idJira
    $scope.issueType = issueType
    $scope.readOnly = readOnly
    $scope.newComment = {}

    $scope.isMyComment = (comment) => AuthService.getAuth().uuid === (comment.commenter && comment.commenter.uuid)

    $scope.refreshComments = () => {
        $scope.refreshingComments = true

        let promise

        if (issueType === 'complaint') {
            promise = ApiAdmin.getComplaintComments({ idIssue: $scope.idJira })
        } else {
            promise = ApiAdmin.getIssueComments({ idIssue: $scope.idJira, issueType })
        }

        promise.$promise.then((comments) => {
            const commentsEnhanced = _.reduce(comments, (accComments, comment) => {
                let author = comment.author
                let displayedComment = JiraService.attachmentCommentCleaner(comment.comment)

                if (author === 'Développeurs ') {
                    const nameMatch = displayedComment.match(/(.*?) : /)

                    author = (nameMatch && nameMatch[1]) || author
                    displayedComment = (nameMatch && displayedComment.replace(nameMatch[0], '')) || displayedComment
                }

                accComments.push(_.assign({}, comment, {
                    displayedComment,
                    author,
                }))

                return accComments
            }, [])

            $scope.comments = _.orderBy(commentsEnhanced, 'date', 'asc')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingComments = false
        })
    }

    $scope.refreshComments()


    const addComment = (isPublic) => {
        if ($scope.postingComment) {
            return
        }
        $scope.postingComment = true
        ApiAdmin.postIssueComment({ idIssue: $scope.idJira, issueType }, { comment: $scope.newComment.text, isPublic }).$promise.then(() => {
            $scope.refreshComments()
            $scope.newComment.text = ''
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.postingComment = false
        })
    }
    $scope.addPublicComment = () => addComment(true)
    $scope.addInternalComment = () => addComment(false)

    $scope.kbconfig = () => ([
        { combo: [17, 13], func: $scope.addInternalComment, data: $scope.newComment },
    ])
})
